import { render, staticRenderFns } from "./duration-span.vue?vue&type=template&id=2ccc840c&"
import script from "./duration-span.vue?vue&type=script&lang=js&"
export * from "./duration-span.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports